import React from 'react';

import SmartLink from 'Shared/components/SmartLink';

import salesForceLogo from './SalesForceLogo.png';
import SalesForceSmartMenu from '../SmartMenu/SalesForceSmartMenu';
import { SmartLinkLogo, SmartLinkContainer } from '../components';

type Props = {
  children: React.ReactNode;
};

const SalesForceLink = ({ children, ...restProps }: Props) => (
  <SmartLinkContainer contentEditable={false}>
    <SalesForceSmartMenu {...restProps}>
      <SmartLink {...restProps}>
        <SmartLinkLogo src={salesForceLogo} />
        {children}
      </SmartLink>
    </SalesForceSmartMenu>
  </SmartLinkContainer>
);

export default SalesForceLink;
